export const FormRestrictionStatus = {
  OPEN: 'open',
  RESTRICTED: 'restricted'
};
export const FormSupportedPrincipalType = {
  USER: 'USER',
  USER_GROUP: 'USER_GROUP'
};

// TODO(amartinez): response API to be confirmed as a part of REQIN-1453.